import Component from '@glimmer/component';

import { concat } from '@ember/helper';

import { classMix } from 'rise-ui/decorators/class-mix.js';
import classMod from 'rise-ui/helpers/class-mod.js';
import classMods from 'rise-ui/helpers/class-mods.js';
import concatClasses from 'rise-ui/helpers/concat-classes.js';
import nom from 'rise-ui/helpers/nom.js';
import or from 'rise-ui/helpers/or.js';

export default class CIconComponent extends Component {
  /** @type {ClassMix} */
  @classMix classMixed;

  <template>
    <span class={{this.classMixed.mixedClassNames}} ...attributes>{{nom~}}
      <span
        class={{concatClasses
          (concat "c-icon c-icon--" @icon)
          (if @modifier (classMod "c-icon-mod" modifiers=(classMods @modifier)))
        }}
        title={{or @title @text}}
      ></span>
      {{~#if @text}}<span class="c-icon__text">{{@text}}</span>{{/if~}}
    </span>{{nom~}}
  </template>
}
